<template>
	<div class="container pb_0">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="sub_title">
						{{ $t('rtr_personal-how-janopay_creditcard.title1') }}
					</p>
					<p class="sub_text">
						{{ $t('rtr_personal-how-janopay_creditcard.text1') }}<br />
						{{ $t('rtr_personal-how-janopay_creditcard.text2') }}<br />
						{{ $t('rtr_personal-how-janopay_creditcard.text3') }}
					</p>
				</div>
			</div>
		</div>

		<section>
			<div class="sub_content1">
				<div class="sub_content">
					<div class="d_flex">
						<div class="detail_area pa_0">
							<div class="detail">
								<h2 class="title">
									{{ $t('rtr_personal-how-janopay_creditcard.title2') }}
								</h2>
								<p class="text mb_30">
									<span class="fw_bold">
										{{
											$t('rtr_personal-how-janopay_creditcard.title3')
										}} </span
									><br />
									{{ $t('rtr_personal-how-janopay_creditcard.text4') }}<br />
									{{ $t('rtr_personal-how-janopay_creditcard.text5') }}
								</p>
								<router-link to class="link_type_03" @click="notYet">
									{{ $t('rtr_personal-how-janopay_creditcard.text26') }}
									<span class="CIRCLE_ARROW"></span>
								</router-link>
								<p class="text mb_30 mt_30">
									<span class="fw_bold"
										>{{ $t('rtr_personal-how-janopay_creditcard.text6') }}<br />
										{{ $t('rtr_personal-how-janopay_creditcard.text7') }}<br
									/></span>
									{{ $t('rtr_personal-how-janopay_creditcard.text8') }}<br />
									{{ $t('rtr_personal-how-janopay_creditcard.text9') }}<br />
									{{ $t('rtr_personal-how-janopay_creditcard.text10') }}
								</p>
								<router-link :to="{ name: 'terms' }" class="link_type_03">
									{{ $t('rtr_personal-how-janopay_creditcard.text27') }}
									<span class="CIRCLE_ARROW"></span>
								</router-link>
							</div>
						</div>
						<div class="img_area">
							<span
								>#{{ $t('rtr_personal-how-janopay_creditcard.text12') }}<br />{{
									$t('rtr_personal-how-janopay_creditcard.text13')
								}}</span
							>
							<span
								>#{{ $t('rtr_personal-how-janopay_creditcard.text14') }}</span
							>
							<span
								>#{{ $t('rtr_personal-how-janopay_creditcard.text15') }}<br />{{
									$t('rtr_personal-how-janopay_creditcard.text16')
								}}</span
							>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="img_area">
						<img src="@/assets/images/sub/janopay_creditcard_03.png" alt="" />
					</div>
					<div class="detail_area">
						<div>
							<h2 class="title">
								<span class="fc_red">{{
									$t('rtr_personal-how-janopay_creditcard.title4')
								}}</span
								><br />
								{{ $t('rtr_personal-how-janopay_creditcard.title5') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-how-janopay_creditcard.text17') }}<br />
								{{ $t('rtr_personal-how-janopay_creditcard.text18') }}<br />
								{{ $t('rtr_personal-how-janopay_creditcard.text19') }}<br />
								{{ $t('rtr_personal-how-janopay_creditcard.text20') }}<br />
								{{ $t('rtr_personal-how-janopay_creditcard.text21') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div>
							<h2 class="title">
								{{ $t('rtr_personal-how-janopay_creditcard.title6') }}
							</h2>
							<p class="text mb_30">
								{{ $t('rtr_personal-how-janopay_creditcard.text22') }}<br />
								{{ $t('rtr_personal-how-janopay_creditcard.text23') }}<br />
								{{ $t('rtr_personal-how-janopay_creditcard.text24') }}
							</p>
							<router-link to class="link_type_02" @click="notYet">
								{{ $t('rtr_personal-how-janopay_creditcard.text25') }}
								<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
					<div class="img_area">
						<img src="@/assets/images/sub/janopay_creditcard_04.png" alt="" />
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'JanopayCreditcard',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>
<style scoped></style>
